export default {
  bind (el, binding, vnode, oldVnode) {
    let resizeEvent = new CustomEvent('drag-resize', { detail: '尺寸变化', bubbles: false })
    el.fullscreen = false
    const minWidth = 400
    const minHeight = 300
    let nowWidth = minWidth
    let nowHeight = minHeight
    let nowMarginTop = 0
    let hasSetBodyHight = false

    const dialogHeaderEl = el.querySelector('.el-dialog__header')
    if (!dialogHeaderEl) return

    const dragDom = el.querySelector('.el-dialog')
    if (!dragDom) return

    dragDom.className += ' el-drag-dialog'

    // 设置 header 样式
    dialogHeaderEl.onselectstart = () => false
    dialogHeaderEl.style.cursor = 'move'

    const sty = dragDom.currentStyle || window.getComputedStyle(dragDom, null)

    // 创建最大化/最小化按钮
    const maxMin = document.createElement('button')
    maxMin.className = 'el-dialog__headerbtn el-dialog__minmax'
    maxMin.style.right = '40px'
    maxMin.style.color = '#909399'
    maxMin.title = el.fullscreen ? '还原' : '最大化'

    const updateMaxMinIcon = (isFullscreen) => {
      const i = document.createElement('i')
      i.className = isFullscreen ? 'el-icon-crop' : 'el-icon-full-screen'
      i.onmouseover = () => i.style.color = '#409EFF'
      i.onmouseout = () => i.style.color = 'inherit'
      maxMin.innerHTML = ''
      maxMin.appendChild(i)
    }

    updateMaxMinIcon(el.fullscreen)
    dialogHeaderEl.insertBefore(maxMin, dialogHeaderEl.childNodes[1])

    // 移动逻辑
    const moveDown = (e) => {
      const disX = e.clientX - dialogHeaderEl.offsetLeft
      const disY = e.clientY - dialogHeaderEl.offsetTop

      let styL, styT
      if (sty.left.includes('%')) {
        styL = document.body.clientWidth * (parseFloat(sty.left) / 100)
        styT = document.body.clientHeight * (parseFloat(sty.top) / 100)
      } else {
        styL = parseFloat(sty.left)
        styT = parseFloat(sty.top)
      }

      document.onmousemove = function (e) {
        const l = e.clientX - disX
        const t = e.clientY - disY
        dragDom.style.left = `${l + styL}px`
        dragDom.style.top = `${t + styT}px`
      }

      document.onmouseup = function () {
        document.onmousemove = null
        document.onmouseup = null
      }
    }

    dialogHeaderEl.onmousedown = moveDown

    // 设置全屏/非全屏状态
    const setMaxMin = () => {
      const bodyEl = dragDom.querySelector('.el-dialog__body')
      const footerEl = dragDom.querySelector('.el-dialog__footer')
      if (!bodyEl || !footerEl) return

      if (el.fullscreen) {
        dragDom.className = dragDom.className.replace(' el-dialog--fullscreen', '')
        updateMaxMinIcon(false)
        maxMin.title = '最大化'
        dragDom.style.height = 'auto'
        dragDom.style.width = nowWidth + 'px'
        dragDom.style.marginTop = nowMarginTop
        el.fullscreen = false
        dialogHeaderEl.style.cursor = 'move'
        dialogHeaderEl.onmousedown = moveDown
        bodyEl.style.height = 'auto'
        hasSetBodyHight = false
        footerEl.style.position = 'static'
      } else {
        dragDom.className += ' el-dialog--fullscreen'
        updateMaxMinIcon(true)
        maxMin.title = '还原'
        nowHeight = dragDom.clientHeight
        nowWidth = dragDom.clientWidth
        nowMarginTop = dragDom.style.marginTop
        dragDom.style.left = '0'
        dragDom.style.top = '0'
        dragDom.style.height = '100vh'
        dragDom.style.width = '100%'
        dragDom.style.marginTop = '0'
        el.fullscreen = true
        dialogHeaderEl.style.cursor = 'initial'
        dialogHeaderEl.onmousedown = null
        if (!hasSetBodyHight) {
          const dialogHeader = dragDom.querySelector('.el-dialog__header')
          const dialogFooter = dragDom.querySelector('.el-dialog__footer')

          const headerHeight = dialogHeader ? dialogHeader.offsetHeight : 0
          const footerHeight = dialogFooter ? dialogFooter.offsetHeight : 0

          const bodyEl = dragDom.querySelector('.el-dialog__body')
          if (bodyEl) {
            bodyEl.style.height = `calc(100% - ${headerHeight + footerHeight + 30}px)`
            hasSetBodyHight = true
          }
        }
      }
      el.dispatchEvent(resizeEvent)
    }

    maxMin.onclick = setMaxMin
    dialogHeaderEl.ondblclick = setMaxMin

    // 创建右下角拖拽区域
    const resizeEl = document.createElement('div')
    resizeEl.style.cssText = `
      cursor: se-resize;
      position: absolute;
      height: 10px;
      width: 10px;
      right: 0px;
      bottom: 0px;
    `
    dragDom.appendChild(resizeEl)

    // 拖拽调整大小
    let bodyHeight = 'auto'
    resizeEl.onmousedown = (e) => {
      const clientX = e.clientX
      const disX = e.clientX - resizeEl.offsetLeft
      const disY = e.clientY - resizeEl.offsetTop

      document.onmousemove = function (e) {
        e.preventDefault()
        const x = e.clientX - disX + (e.clientX - clientX)
        const y = e.clientY - disY
        dragDom.style.width = x > minWidth ? `${x}px` : `${minWidth}px`
        dragDom.style.height = y > minHeight ? `${y}px` : `${minHeight}px`

        if (!hasSetBodyHight) {
          const bodyEl = dragDom.querySelector('.el-dialog__body')
          const footerEl = dragDom.querySelector('.el-dialog__footer')
          const footerHeight = footerEl ? footerEl.offsetHeight : 0
          bodyEl.style.height = `calc(100% - ${dialogHeaderEl.offsetHeight + footerHeight + 30}px)`
          hasSetBodyHight = true
        }
      }

      document.onmouseup = function () {
        document.onmousemove = null
        document.onmouseup = null
        el.dispatchEvent(resizeEvent)
      }
    }
    // 右侧拖拽调整宽度
    const lineEl = document.createElement('div')
    lineEl.style =
      'width: 2px; background: inherit; height: 100%; position: absolute; right: 0; top: 0; bottom: 0; margin: auto; z-index: 1; cursor: w-resize;'
    lineEl.addEventListener(
      'mousedown',
      function (e) {
        // 鼠标按下，计算当前元素距离可视区的距离
        const disX = e.clientX - el.offsetLeft
        // 当前宽度
        const curWidth = dragDom.offsetWidth
        document.onmousemove = function (e) {
          e.preventDefault() // 移动时禁用默认事件
          // 通过事件委托，计算移动的距离
          const l = e.clientX - disX
          const x = curWidth + l
          dragDom.style.width = x > minWidth ? `${x}px` : `${minWidth}px`
        }

        document.onmouseup = function (e) {
          document.onmousemove = null
          document.onmouseup = null
        }
      },
      false
    )
    dragDom.appendChild(lineEl)
  },

  unbind (el) {
    // 清理全局事件监听
    document.onmousemove = null
    document.onmouseup = null
  }
}
